// extracted by mini-css-extract-plugin
export default {"preloader":"CardHeaderAvatarPreloader_preloader__G1CDB","skeleton":"CardHeaderAvatarPreloader_skeleton__It7oG"};